<div class="side-entity-container">
  <div class="loading-overlay" *ngIf="loading || isSaving">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
  <div class="form-wrapper" *ngIf="editableRecord">
    <div class="form-section">
      <div class="section-header" (click)="data.sections[0].isExpanded = !data.sections[0].isExpanded">
        <span>{{ sectionTitle }}</span>
        <mat-icon>{{ data.sections[0].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      <div class="section-content" *ngIf="data.sections[0].isExpanded">
        <!-- Loop over the dynamically generated formFields -->
        <div *ngFor="let field of formFields" class="form-row">
          <label class="form-label">{{ field.label }}</label>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput [(ngModel)]="editableRecord[field.key]">
          </mat-form-field>
        </div>
      </div>
      
      <div class="form-actions" *ngIf="data.sections[0].isExpanded">
        <hr class="divider" />
        <div class="action-buttons-container">
          <!-- The actions can still come from the config -->
          <button *ngFor="let action of data.sections[0].actions" mat-flat-button [class]="action.style" (click)="handleAction(action.actionId)" [disabled]="isSaving">
            {{ action.label }}
          </button>
        </div>
      </div>
    </div>

    <!-- This part for 'Related Entities' can remain as is -->
    <div class.form-section *ngIf="data.sections[1]">
        <div class="section-header" (click)="data.sections[1].isExpanded = !data.sections[1].isExpanded">
            <span>{{ data.sections[1].title }}</span>
            <mat-icon>{{ data.sections[1].isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
      <div class="section-content" *ngIf="data.sections[1].isExpanded">
          <p>Related entities content placeholder.</p>
      </div>
    </div>

  </div>
  <div *ngIf="!editableRecord && !loading" class="no-record-message">
    Select a record to view its details.
  </div>
</div>